import React from "react";
import { calcMonthlyRate, fmtEUR } from "@/lib/finance";

/**
 * PAngV-Pflichtangaben (§ 6a PAngV) – repräsentatives Beispiel auf Basis der
 * Standardkonditionen. Muss überall erscheinen, wo Finanzierungsraten beworben werden.
 */
export default function FinanceLegalNote({ className = "" }) {
  const ex = calcMonthlyRate(50000); // repräsentatives Beispiel
  const pct = ex.annualRate.toFixed(2).replace(".", ",");
  return (
    <p className={`text-[10px] leading-relaxed text-zinc-500 ${className}`} data-testid="finance-legal-note">
      <strong className="text-zinc-400">* Repräsentatives Beispiel gemäß § 6a PAngV:</strong>{" "}
      Nettodarlehensbetrag {fmtEUR(ex.financingAmount)} · Laufzeit {ex.term} Monate · gebundener Sollzinssatz{" "}
      {pct} % p. a. · effektiver Jahreszins {pct} % · Anzahlung {fmtEUR(ex.down)} · monatliche Rate {fmtEUR(ex.rate)} ·
      Schlussrate {fmtEUR(ex.balloon)} · Gesamtbetrag {fmtEUR(ex.totalRepayment)}. Kreditvermittler (ungebunden,
      § 655a BGB): {ex.partner}. Bonität vorausgesetzt. Alle Angaben unverbindlich und ohne Gewähr.
    </p>
  );
}
